import React, { Component } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';

export default function withHeaderTab(options = {}) {
  const {
    tabs = [],
    noPaper = false,
    propsTabs = {}
  } = options;

  return WrappedComponent =>
    (class withHeaderTab extends Component {
      state = { tab: 0 };

      setTab = (e, tab) => this.setState({ tab });

      render() {
        const { tab } = this.state;
        const genTabs = !!tabs.length && <Tabs
          key={'Tabs'}
          onChange={this.setTab}
          value={tab}
          indicatorColor={'primary'}
          textColor={'primary'}
          variant="scrollable"
          scrollButtons="auto"
          centered
          {...propsTabs}
          children={tabs.map((e) => (
            <Tab key={`${e.label}`} {...e} />
          ))}
        />;
        return [
          !!genTabs && (noPaper ? genTabs :
            <Paper children={genTabs} />),
          <WrappedComponent
            key={'WrappedComponent'}
            {...this.props}
            tab={tab}
          />,
        ];
      }
    });
}
